import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import Api from '../../../../Global/Modules/Api'

const FETCH_URL = 'api/members/'
class BeoordelingsDocumentUpload extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            opmerking: '',
            errors: {}
        }

    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ [name]: value })
    }
    handleSubmit(event) {
        event.preventDefault()
        var formData = new FormData()
        formData.append('description', this.state.opmerking)
        formData.append('id', this.props.id)
        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)


        // TODO: Post payload to the API
        Api.PostApiWithFile(FETCH_URL + this.props.id + "/assestments", formData, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    Api.print(response)
                    this.setState({ errors: response });
                }
                else {
                    alert("Document created")
                    window.location.href = "/admin/leden/lid/beoordelingsdocumenten/" + this.props.id
                }
            })
    }
    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <h4><strong>Bestand uploaden</strong></h4>
                <FormGroup controlId="BeoordelingsDocumentUpload">
                    <Col componentClass={ControlLabel} sm={4}>
                        Bestand
                    </Col>

                    <Col sm={6}>
                        <FormControl type="File" inputRef={input => this.fileInput = input} />
                        {Api.showError(errors, "file")}
                    </Col>

                </FormGroup>
                <FormGroup controlId="BeoordelingsDocumentOpmerking">
                    <Col componentClass={ControlLabel} sm={4}>
                        Opmerking
                    </Col>
                    <Col sm={6}>
                        <FormControl name="opmerking" type="text" required value={this.state.opmerking} onChange={this.handleChange} />
                        {Api.showError(errors, "name")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default BeoordelingsDocumentUpload;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/BeoordelingsDocumentenAdd.js